import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding-bottom: 24px;

  @media (max-width: 768px) {
    gap: 8px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const TitleSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  gap: 6px;

  @media (max-width: 480px) {
    width: 100%;
  }
`

export const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`

export const TitleText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;

  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
`

export const ParentTitle = styled.h6`
  font-weight: 400;
  color: ${Tokens.ColorTextPrimary};
  padding-bottom: 3px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    text-decoration-color: inherit;
  }
`

export const ActionsSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 480px) {
    width: 100%;
    justify-content: flex-end;
  }
`
